import { useSelector } from "react-redux";

import useGroupAvailability from "web/hooks/useGroupAvailability";

import dateFormatterWithDots from "web/utils/data/parser/dateAndTime/dateFormatterWithDots";

import { useAppContext } from "web/context/app";
import {
  useGetEmployeeConfigurationQuery,
  useGetEmployeeDetailsQuery,
} from "web/features/employee/employeeApiSlice";

import canShowBanner from "./canShowBanner";
import SubscriptionBanner from "./subscriptionBanner";
import classes from "./subscriptionBannerWrapper.scss";

const SubscriptionBannerWrapper = () => {
  const { data: employeeDetails } = useGetEmployeeDetailsQuery();
  const { isMobile } = useAppContext();

  // switch - don't show subscriptions' banner for employee group
  const { alternativeStartPageDisabled: disableBannerForEmployeeGroup } =
    employeeDetails || {};

  const { data: employeeConfig } = useGetEmployeeConfigurationQuery();
  const {
    alternativeStartPageOverride: enableBannerAlways, // switch - always show subscriptions' banner
    alternativeStartPageOverrideUMS: enableBannerAlwaysUMS,
    bannerForEmployeeWithoutDraft, // show banner to users who never passed configurator
    bannerForEmployeeWithoutDraftUMS,
    bannerContent,
    bannerContentUMS,
  } = employeeConfig || {};

  const { config, hasEnabledAnySubscriptions } = useSelector(
    (state) => state.subscriptionQuote
  );

  const [hasBothGroupEnabled, isGroupAvailable] = useGroupAvailability();

  let defaultGroupConfig = {
    // case when both groups OR only I group is enabled
    isWindowOpen: config?.open,
    chooseSubscriptionsTo: config?.chooseSubscriptionsTo,
    startSubscriptionsFrom: config?.startSubscriptionsFrom,
    lastConfigurationDone: config?.lastConfigurationDone,
    enableBannerAlways,
    bannerForEmployeeWithoutDraft,
  };

  // Never show banner if subscriptions are disabled or banner is disabled for employee group
  if (!hasEnabledAnySubscriptions || disableBannerForEmployeeGroup) {
    return null;
  }

  const isGroupOneAvailable = isGroupAvailable(1);
  const isGroupTwoAvailable = isGroupAvailable(2);

  if (!hasBothGroupEnabled && isGroupTwoAvailable) {
    // case when only UMS is enabled
    defaultGroupConfig = {
      ...defaultGroupConfig,
      isWindowOpen: config.openUms,
      chooseSubscriptionsTo: config?.chooseUmsSubscriptionsTo,
      startSubscriptionsFrom: config?.startUmsSubscriptionsFrom,
      enableBannerAlways: enableBannerAlwaysUMS,
      bannerForEmployeeWithoutDraft: bannerForEmployeeWithoutDraftUMS,
    };
  }

  const windowDate = {
    fullDateToDate: dateFormatterWithDots(
      defaultGroupConfig.chooseSubscriptionsTo
    ),
    fullDateFromDate: dateFormatterWithDots(
      defaultGroupConfig.startSubscriptionsFrom
    ),
  };

  const showBannerFlag = canShowBanner(defaultGroupConfig);

  return showBannerFlag ? (
    <div className={`${classes.root} ${isMobile ? "" : "container"}`}>
      <SubscriptionBanner
        finalDates={windowDate}
        bannerContent={bannerContent}
        bannerContentUMS={bannerContentUMS}
        hasBothGroupsEnabled={hasBothGroupEnabled}
        isGroupOneAvailable={isGroupOneAvailable}
        isGroupTwoAvailable={isGroupTwoAvailable}
      />
    </div>
  ) : null;
};

export default SubscriptionBannerWrapper;
